<template>
  <main class="service-page">
    <modal-dialog
      persistent
      max-width="500px"
      title="Вы действительно хотите безвозвратно удалить категорию со всем содержимым?"
      v-model="shownDialogConfirmDeleteCategory"
      with-cross
      class="service-page__dialog"
    >
      <div class="service-page__dialog__buttons">
        <button
          class="service-page__dialog__button positive"
          type="button"
          v-on:click="shownDialogConfirmDeleteCategory = false"
        >Нет</button>
        <button
          class="service-page__dialog__button negative"
          type="button"
          v-on:click="onDeleteCategory"
        >Да, удалить</button>
      </div>
    </modal-dialog>
    <modal-dialog
      persistent
      max-width="500px"
      title="Вы действительно хотите удалить услугу?"
      v-model="shownDialogConfirmDeleteService"
      with-cross
      class="service-page__dialog"
    >
      <div class="service-page__dialog__buttons">
        <button
          class="service-page__dialog__button positive"
          type="button"
          v-on:click="shownDialogConfirmDeleteService = false"
        >Нет</button>
        <button
          class="service-page__dialog__button negative"
          type="button"
          v-on:click="onDeleteService"
        >Да, удалить</button>
      </div>
    </modal-dialog>
    <modal-dialog
      with-cross
      max-width="450px"
      title="Изменить стоимость"
      v-on:input="onCloseIncreaseServicePricesModal"
      v-bind:value="isShowIncreaseServicePricesModal"
      v-on:on-click-outside="onCloseIncreaseServicePricesModal"
    >
      <increase-service-prices-modal
        v-bind:input-error="inputErrors"
        v-bind:services="increaseServicePrices"
        v-on:submit="onIncreaseServicePrice"
        v-on:cancel="onCloseIncreaseServicePricesModal"
      />
    </modal-dialog>
    <div class="service-page__body">
      <button-back />
      <h1 class="service-page__title">
        <span>
          Прайс
        </span>
        <button
          type="button"
          v-on:click="showHintDialog = true"
        >
          ? Как настроить
        </button>
      </h1>
      <next-step-setting-instruction
        v-bind:current-route-name="$route.name"
        v-bind:available-steps="instructionSteps"
      >
        <div class="service-page__header__buttons">
          <button
            class="service-page__header__button-add"
            id="price-list-button-creating-function-parent-1"
            type="button"
            v-if="hasCreate"
            v-on:click="openServiceItemForm"
          >Добавить</button>
          <button
            v-if="isAllowIncreasePrice"
            type="button"
            class="service-page__header__button-edit-prices"
            v-on:click="onOpenIncreaseServicePricesModal"
          >
            Изменить цены
          </button>
          <button
            class="service-page__header__button-export"
            type="button"
            v-bind:disabled="disabledExport"
            v-on:click="onExportExcel"
          >Скачать прайс</button>
        </div>
      </next-step-setting-instruction>
      <div class="service-page__header">
        <div class="service-page__header__left">
          <input-text-search
            class="service-page__search"
            placeholder="Введите название услуги"
            v-bind:violations="searchViolations"
            v-model="searchQuery"
            v-on:input="searchServiceList" />
        </div>
      </div>
      <div class="service-page__body__row">
        <div class="service-page__categories">
          <div class="service-page__categories__caption">Список прайсов</div>
          <div class="service-page__categories__container">
            <category-item
              v-show="inSearchProcess"
              v-bind:category="$options.allCategory"
              v-bind:has-delete="false"
              v-bind:has-edit="false"
              v-bind:selected-category="!!categoryId ? categoryId : -1"
              v-on:select-category="onSelectingSearchCategory"
            />
            <category-item
              v-show="inSearchProcess"
              v-for="item in sortedCategoryList"
              v-bind:category="item"
              v-bind:has-delete="hasDelete"
              v-bind:has-edit="hasEdit"
              v-bind:key="item.id"
              v-bind:selected-category="!!categoryId ? categoryId : -1"
              v-on:delete-category="onOpenDialogConfirmDeleteCategory"
              v-on:edit-category="onOpenCategoryForm"
              v-on:select-category="onSelectingSearchCategory"
            />
            <category-item
              v-bind:category="$options.favoriteCategory"
              v-bind:has-delete="false"
              v-bind:has-edit="false"
              v-bind:selected-category="!!categoryId ? categoryId : -1"
              v-on:select-category="onSelectingCategory"
            />
            <price-list
              v-bind:prices="pricesList"
              v-bind:has-delete="hasDelete"
              v-bind:has-edit="hasEdit"
              v-bind:init-service-price-list-panel="servicePriceListPanel"
              v-bind:selected-category="!!categoryId ? categoryId : -1"
              v-bind:drag-selected-element="dragSelectedElement"
              v-on:set-drag-select="onSetDragSelectedElement"
              v-on:delete-category="onOpenDialogConfirmDeleteCategory"
              v-on:delete-price-list="onDeleteServicePriceList"
              v-on:edit-price-list="onOpenServicePriceListSidebar"
              v-on:edit-category="onOpenCategoryFormByPrice"
              v-on:select-category="onSelectingCategory"
              v-on:change-order-categories=" onChangeOrderCategory"

            />
          </div>
        </div>
        <div
          v-if="message"
          class="service-message"
          v-on:click="message.action"
        >{{ message.text }}</div>
        <service-table
          v-else
          v-bind:actions="actions"
          v-bind:service-tax-code-options="$options.serviceTaxCodeOptions"
          v-bind:service-list="serviceList"
          v-bind:shown-search-columns="shownSearchColumns"
          v-on:copy="onCopyService"
          v-on:delete="onOpenDialogConfirmDeleteService"
          v-on:edit="onEditService"
          v-on:toggle-favorite="onToggleFavorite"
          v-on:toggle-hidden="onToggleHidden"
          v-on:view="onOpenServiceForm"
          v-on:remove-selected-service="onRemoveFromIncreaseServices"
          v-on:add-selected-service="onAddToIncreaseServices"
          v-on:change-order-service="onChangeOrderServices"
        />
      </div>
    </div>
    <side-slide-transition>
      <confirm-side-dialog
        v-if="hasOpenForm && formName === $options.formServiceItem"
        class="side-absolute"
        v-bind:need-confirm="needConfirmPriceForm"
        v-bind:label="'Добавить'"
        v-on:cancel="onCloseForm"
      >
        <form-service-item
          v-bind:service-price-list="pricesList"
          v-bind:category-list="categoryList"
          v-bind:inputErrors="inputErrors"
          v-on:close="onCloseForm"
          v-on:submit-category="onFormCategorySubmit"
          v-on:submit-price-list="onCreateServicePriceList"
          v-on:submit-service="onFormServiceSubmit"
          v-on:change-values="onChangeFieldValues"
          v-on:set-tax-code-for-all-services-in-category="onSetTaxCodeForAllServicesInCategory"
        />
      </confirm-side-dialog>
      <confirm-side-dialog
        v-if="hasOpenForm && formName === $options.formPrice"
        class="side-absolute"
        v-bind:need-confirm="needConfirmPriceForm"
        v-bind:label="formTitle"
        v-on:cancel="onCloseForm"
      >
        <form-price
          v-bind:inputErrors="inputErrors"
          v-bind:initial-service-price-list="selectedPrice"
          v-on:close="onCloseForm"
          v-on:on-create-price-list="onCreateServicePriceList"
          v-on:on-edit-price-list="onEditServicePriceList"
          v-on:change-values="onChangeFieldValues"
        />
      </confirm-side-dialog>
      <confirm-side-dialog
        v-if="hasOpenForm && formName === $options.formCategory"
        class="side-absolute"
        v-bind:need-confirm="needConfirmCategoryForm"
        v-bind:label="formTitle"
        v-on:cancel="onCloseForm"
      >
        <form-service-category-creation
          v-bind:inputErrors="inputErrors"
          v-bind="selectedCategoryProps"
          v-bind:initial-category-list="categoryList"
          v-bind:price-list="pricesList"
          v-on:close="onCloseForm"
          v-on:form-submit="onFormCategorySubmit"
          v-on:change-values="onChangeFieldValues"
        />
      </confirm-side-dialog>
      <confirm-side-dialog
        v-else-if="hasOpenForm && formName === $options.formService"
        class="side-absolute"
        v-bind:need-confirm="needConfirmServiceForm"
        v-bind:label="formTitle"
        v-on:cancel="onCloseForm"
      >
        <form-service-creation
          v-bind:init-price-list="pricesList"
          v-bind:current-category-id="categoryId"
          v-bind:input-errors="inputErrors"
          v-bind:categories-without-price="categoryList"
          v-bind:service-tax-code-options="$options.serviceTaxCodeOptions"
          v-bind="serviceProps"
          v-on:set-tax-code-for-all-services-in-category="onSetTaxCodeForAllServicesInCategory"
          v-on:close="onCloseForm"
          v-on:form-submit="onFormServiceSubmit"
          v-on:change-values="onChangeFieldValues"
        />
      </confirm-side-dialog>
    </side-slide-transition>
    <confirm-side-dialog
      label="Как работать с разделом «Прайс»"
      v-if="showHintDialog"
      v-on:cancel="showHintDialog = false"
      class="service-page__modal"
    >
      <div class="service-page__modal__article">
        <div>
          <p>
            Здесь находится перечень медицинских услуг.
            Данные услуги используются при создании визита и&nbsp;плана лечения.
          </p>
          <p>
            Вы можете создавать новые прайсы, категории и&nbsp;услуги, а&nbsp;также
            редактировать и&nbsp;удалять существующие.
          </p>
        </div>
        <section>
          <h4>Чтобы создать новый прайс, нажмите «+Добавить».</h4>
          <p>В открывшемся окне укажите:</p>
          <ol>
            <li>Тип - Прайс-лист</li>
            <li>Название прайса</li>
          </ol>
          <p>Нажмите «Сохранить».</p>
          <zoom-image
            v-bind:src="require('@/assets/img/help/new/prices/price-1.png')"
            alt="Создание нового прайса"
            class="service-page__modal__img"
          />
        </section>
        <section>
          <h4>Чтобы создать новую категорию, нажмите «+Добавить».</h4>
          <p>В открывшемся окне укажите:</p>
          <ol>
            <li>Тип - Категория</li>
            <li>Название категории</li>
            <li>Наличие родительской категории</li>
            <li>Прайс</li>
          </ol>
          <p>Нажмите «Сохранить».</p>
          <zoom-image
            v-bind:src="require('@/assets/img/help/new/prices/price-2.png')"
            alt="Создание новой категории"
            class="service-page__modal__img"
          />
        </section>
        <section>
          <h4>Чтобы создать новую услугу, нажмите кнопку «+Добавить».</h4>
          <p>В открывшемся окне заполните:</p>
          <ol>
            <li>Тип - Услуга</li>
            <li>Название услуги</li>
            <li>
              Код номенклатуры (перечень кодов и наименований медицинских услуг,
              утвержденный приказом Минздрава&nbsp;№804н)
            </li>
            <li>Код клиники (внутренний код клиники)</li>
            <li>Прайс</li>
            <li>Категория</li>
            <li>Стоимость в рублях</li>
            <li>Признак расчета</li>
            <li>Код услуги  (для формирования справки 3-НДФЛ)</li>
          </ol>
          <p>Нажмите «Сохранить».</p>
          <zoom-image
            v-bind:src="require('@/assets/img/help/new/prices/price-3.png')"
            alt="Создание новой услуги"
            class="service-page__modal__img"
          />
        </section>
        <section>
          <h4>Как сделать услугу временно недоступной в прайсе?</h4>
          <p>
            Для этого выберите услугу которую хотите скрыть и&nbsp;отключите бегунок
            "Выводить в&nbsp;прайсе". Позиция не будет высвечиваться при выборе услуг.
          </p>
          <zoom-image
            v-bind:src="require('@/assets/img/help/new/prices/price-4.png')"
            alt="Временно недоступная услуга в прайсе"
            class="service-page__modal__img"
          />
        </section>
        <section>
          <h4>Массовое повышение цены на услуги</h4>
          <p>
            Для того, чтобы массово увеличить стоимость услуг выполните следующие действия:
          </p>
          <ol>
            <li>Выберите чек-боксами необходимые услуги</li>
            <li>Нажмите кнопку Изменить цены</li>
            <li>Установите процент повышения</li>
            <li>Нажмите кнопку Отправить</li>
          </ol>
          <zoom-image
            v-bind:src="require('@/assets/img/help/new/prices/price-5.png')"
            alt="Массовое повышение цены на услуги"
            class="service-page__modal__img"
          />
        </section>
        <section>
          <h4>Как скачать прайс?</h4>
          <p>Прайс можно скачать в формате .xls, нажав на кнопку «Скачать прайс».</p>
        </section>
        <section>
          <h4>Как загрузить свой прайс?</h4>
          <p>
            Отправьте прайс в формате XLS на нашу почту help@32top.ru,
            и мы самостоятельно загрузим его в&nbsp;МИС.
          </p>
        </section>
      </div>
    </confirm-side-dialog>
    <on-boarding-dialog
      v-if="isShowOnboarding"
      :is-page-ready="isReadyToOnBoarding"
      :is-show-button-edit-price-price-list="isShowButtonEditPricePriceList"
      :is-show-buttons-creating-functions-price-list="isShowButtonsCreatingFunctionsPriceList"
      @showed="showedOnboarding"
    >
      <price-input
        id="price-list-button-price-edit-child"
        class="service-page__on-boarding__edit-price"
        v-if="isShowButtonEditPricePriceList"
        v-bind:value="parseFloat(0) * 100"
        v-bind:disabled="true"
      />
      <button
        v-if="isShowButtonsCreatingFunctionsPriceList"
        disabled
        id="price-list-button-creating-function-child-1"
        class="service-page__on-boarding__add"
        type="button"
      >Добавить</button>
    </on-boarding-dialog>
  </main>
</template>

<script>
import CategoryItem from '@/components/CategoryItem.vue';
import FormServiceCategoryCreation from '@/components/FormServiceCategoryCreation.vue';
import FormServiceCreation from '@/components/FormServiceCreation.vue';
import ServiceTable from '@/components/ServiceTable.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import ViolationList from '@/utils/violationList';
import violations from '@/violations.json';
import { validateServiceName, validateServiceUnits } from '@/inputConstraint';
import notifierMixin from '@/mixins/notifierMixin';
import debounce from 'lodash.debounce';
import ModalDialog from '@/components/ModalDialog.vue';
import InputTextSearch from '@/components/InputTextSearch.vue';
import { Maybe } from 'monet';
import { CreateServiceRequest, EditServiceRequest } from '@/storage/gateways/ServiceGateway';
import settingInstructionMixin from '@/mixins/settingInstructionMixin';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import ZoomImage from '@/components/ZoomImage.vue';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import ButtonBack from '@/components/ButtonBack.vue';
import NextStepSettingInstruction from '@/components/NextStepSettingInstruction.vue';
import onBoardingMixin from '@/mixins/onBoardingMixin';
import OnBoardingDialog from '@/components/OnBoardingDialog.vue';
import onBoardingShowMixin from '@/mixins/onBoardingShowMixin';
import PriceInput from '@/components/PriceInput.vue';
import PriceList from '@/components/PriceList.vue';
import FormPrice from '@/components/FormPrice.vue';
import FormServiceItem from '@/components/FormServiceItem.vue';
import IncreaseServicePricesModal from '@/components/IncreaseServicePricesModal.vue';

/**
 * @description Название формы создания прайса
 *
 * @type {string}
 */
const FORM_PRICE = FormPrice.name;

/**
 * @description Название формы создания элементов услуг
 *
 * @type {string}
 */
const FORM_SERVICE_ITEM = FormServiceItem.name;

/**
 * @description Название формы создания категории
 *
 * @type {string}
 */
const FORM_CATEGORY = FormServiceCategoryCreation.name;
/**
 * @description Название формы создания услуги
 *
 * @type {string}
 */
const FORM_SERVICE = FormServiceCreation.name;

const needConfirm = (form) => ({ needConfirmBeforeClosed }) => needConfirmBeforeClosed[form];

/**
 * @description Сохранить файл.
 * @param {any}    file Файл.
 * @param {string} name Название файла.
 */
function saveFile(file, name) {
  const obj = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = obj;
  link.target = '_blank';
  link.download = name;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Примесь категорий.
 * @type {Vue}
 */
const categoryMixin = {
  computed: {
    /**
     * @description Заголовок формы прайса.
     * @type {string}
     */
    formPriceTitle() {
      return this.selectedPriceName
        ? 'Редактирование прайс-листа'
        : 'Создание прайс-листа';
    },
    /**
     * @description Наименование выбранного прайса.
     * @type {string|null}
     */
    selectedPriceName() {
      return this.selectedPrice.fold(null)((price) => price.name);
    },
    /**
     * @description Идентификатор категории.
     * @type {number|string|null}
     */
    categoryId() {
      return this.category.fold(null)((category) => category.id);
    },
    /**
     * @description Заголовок формы категорий.
     * @type {string}
     */
    formCategoryTitle() {
      return this.selectedCategoryId !== null
        ? 'Редактирование категории'
        : 'Создание категории';
    },
    /**
     * @description Идентификатор выбранной категории.
     * @type {number|string|null}
     */
    selectedCategoryId() {
      return this.selectedCategory.fold(null)((category) => category.id);
    },
    /**
     * @description Поля категории.
     * @type {any}
     */
    selectedCategoryProps() {
      return this.selectedCategory.fold({})((category) => ({
        initialId: category.id,
        initialName: category.name,
        initialParentCategoryId: category.parentCategoryId,
        initialPriceId: category.priceId,
        initialOrder: category.order,
      }));
    },
    /**
     * @description Отсортированный список категорий с подкатегориями.
     * @type {Array}
     */
    sortedCategoryList() {
      const subcategories = this.categoryList
        .filter((category) => category.parentCategoryId);
      const categories = this.categoryList.filter((category) => !category.parentCategoryId);

      subcategories.reverse().forEach((subcategory) => {
        const index = categories.map((e) => e.id).indexOf(subcategory.parentCategoryId);
        categories.splice(index + 1, 0, subcategory);
      });
      return categories;
    },
  },
  data() {
    return {
      /**
       * @description Категория.
       * @type {Maybe<CategoryItem>}
       */
      category: Maybe.none(),
      /**
       * @description Категория над которой будут выполняться действия.
       * @type {Maybe<CategoryItem>}
       */
      selectedCategory: Maybe.none(),
      /**
       * @description Выбранный Прайс категории.
       * @type {Maybe<ServicePriceList>}
       */
      selectedPrice: Maybe.none(),
      /**
       * @description Показывать диалог подтверждения удаления категории.
       * @type {boolean}
       */
      shownDialogConfirmDeleteCategory: false,
    };
  },
  methods: {
    /**
     * @description Обработать событие редактирования прайс-листа.
     *
     * @param id
     *
     * @returns {void}
     */
    onOpenServicePriceListSidebar(id) {
      const price = this.pricesList.find((candidate) => candidate.id === id);
      this.openPriceForm(price);
    },
    /**
     * @description Обработать событие удаления.
     * @param id
     * @return {void}
     */
    async onDeleteServicePriceList(id) {
      if (id === null) {
        this.notifyFail('Удаление прайса по умолчанию невозможно');
        return;
      }
      const dialog = await this.showAcceptDialog('Вы действительно хотите удалить прайс-лист?');
      if (dialog.result !== DialogResult.YES) {
        return;
      }
      const onFail = (error) => { this.notifyFail(error.getTitle()); };
      const onSuccess = (result) => {
        this.fetchServiceCategoriesList();
        this.notifySuccess(result.message);
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .deleteServicePriceList(id)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Получить список услуг по категории.
     * @param {number|string} categoryId
     * @returns {void}
     */
    fetchServicesByCategory(categoryId) {
      this.isAwaitLoadServices = true;
      this
        .$serviceGateway
        .getServiceListForView(categoryId)
        .then((list) => { this.serviceList = list; })
        .finally(() => { this.isAwaitLoadServices = false; });
    },
    /**
     * @description Обработать создание категории.
     * @param {any} request Запрос.
     * @returns {void}
     */
    onCreateCategory(request) {
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = async ({ category, message }) => {
        await this.fetchServiceCategoriesList();
        this.onSelectingCategory(category.id);
        this.notifySuccess(message);
        this.onCloseForm();
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .sendCreateCategory(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать удаление категории.
     * @returns {void}
     */
    onDeleteCategory() {
      const { selectedCategoryId } = this;
      const { categoryId } = this;
      const onFail = (error) => { this.notifyFail(error.getTitle()); };
      const onSuccess = (result) => {
        this.fetchServiceCategoriesList();
        this.notifySuccess(result.message);
        this.shownDialogConfirmDeleteCategory = false;
        if (selectedCategoryId === categoryId) {
          const [first] = this.categoryList;
          if (first) {
            this.onSelectingCategory(first.id);
          }
        }
        this.onCloseForm();
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .sendDeleteServiceCategory(selectedCategoryId)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать изменение категорий.
     * @param {any} request Запрос.
     * @returns {Promise<void>}
     */
    async onEditCategories(request) {
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = ({ message }) => {
        this.notifySuccess(message);
      };
      this.isAwaitRequest = true;
      await this
        .$serviceGateway
        .sendEditCategories(request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать изменение категории.
     * @param {any} request Запрос.
     * @returns {void}
     */
    onEditCategory(request) {
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = ({ category, message }) => {
        const index = this.categoryList.findIndex((item) => item.id === category.id);
        this.$set(this.categoryList, index, category);
        this.fetchServiceCategoriesList();
        this.category = Maybe.some(category);
        this.notifySuccess(message);
        this.onCloseForm();
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .sendEditCategory(this.selectedCategoryId, request)
        .then((result) => {
          result.fold(onFail, onSuccess);
        })
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать отправку формы категории.
     * @type {any} request Запрос.
     * @returns {void}
     */
    onFormCategorySubmit(request) {
      if (this.selectedCategoryId !== null) {
        this.onEditCategory(request);
      } else {
        this.onCreateCategory(request);
      }
    },
    /**
     * @description Редактировать прайс-лист.
     * @type {any} request Запрос.
     * @returns {void}
     */
    onEditServicePriceList(request) {
      this.isAwaitRequest = true;
      if (request.id === '') {
        this.notifyFail('Редактирование прайса по умолчанию невозможно');
        return;
      }
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = ({ message }) => {
        this.fetchServiceCategoriesList();
        this.onCloseForm();
        this.notifySuccess(message);
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .editServicePriceList(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать отправку формы создания нового прайса.
     * @type {any} request Запрос.
     * @returns {void}
     */
    onCreateServicePriceList(request) {
      this.isAwaitRequest = true;
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (message) => {
        this.fetchServiceCategoriesList();
        this.onCloseForm();
        this.notifySuccess(message);
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .addServicePriceList(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать открытие формы категории.
     * @param {number|null} categoryId Идентификатор категории.
     * @returns {void}
     */
    onOpenCategoryForm(categoryId = null) {
      const category = categoryId
        ? this.categoryList.find((candidate) => candidate.id === categoryId)
        : null;
      this.openCategoryForm(category);
    },
    /**
     * @description Обработать открытие формы категории по прайсу.
     *
     * @param {number|null} categoryId Id категории
     * @param {number|null} priceId Id прайса
     */
    onOpenCategoryFormByPrice(categoryId, priceId) {
      const price = this.pricesList.find((candidate) => candidate.id === priceId);
      const category = price
        .serviceCategories
        .find((candidate) => candidate.id === categoryId);
      this.openCategoryForm(category, price);
    },
    /**
     * @description Обработать открытие диалога подтверждения удаления категории.
     * @param categoryId Id категории
     * @param servicePriceListId Id Прайса
     * @returns {void}
     */
    onOpenDialogConfirmDeleteCategory(categoryId, servicePriceListId) {
      const category = (servicePriceListId && categoryId)
        ? this.findCategoryFromServicePriceList(categoryId, servicePriceListId)
        : this.findCategoryFromDefaultServicePriceList(categoryId);
      this.selectedCategory = Maybe.fromEmpty(category);
      this.selectedCategory.forEach(() => { this.shownDialogConfirmDeleteCategory = true; });
    },
    /**
     * @description Обработать выбор категории.
     * @param categoryId Id категории
     * @returns {void}
     */
    onSelectingCategory(categoryId) {
      this.shownSearchColumns = false;
      const servicePriceListId = this.getServicePriceListIdByCategoryId(categoryId);
      const category = (servicePriceListId && categoryId)
        ? this.findCategoryFromServicePriceList(categoryId, servicePriceListId)
        : this.findCategoryFromDefaultServicePriceList(categoryId);
      this.category = Maybe.fromEmpty(category);
      this.category.forEach(() => {
        if (category?.services) {
          this.serviceList = [...category.services];
          return;
        }
        this.fetchServicesByCategory(category.id);
      });
    },
    /**
     * @description Получить Id прайс-листа по Id категории.
     * @param {number} categoryId
     * @returns {number|null}
     */
    getServicePriceListIdByCategoryId(categoryId) {
      return this
        .pricesList
        .find(
          (priceList) => priceList
            .serviceCategories
            .some((category) => category.id === categoryId),
        )
        ?.id;
    },
    /**
     * @description Обработать выбор категории по поиску.
     * @param categoryId Id категории
     * @returns {void}
     */
    onSelectingSearchCategory(categoryId) {
      this.shownSearchColumns = true;
      if (categoryId === this.$options.allCategory.id) {
        this.category = Maybe.fromEmpty(this.$options.allCategory);
        this.serviceList = this.$options.allCategory.services;
        return;
      }
      const category = this.categoryList.find((candidate) => candidate.id === categoryId);
      this.category = Maybe.fromEmpty(category);
      this.category.forEach(() => {
        if (category?.services) {
          this.serviceList = [...category.services];
          return;
        }
        this.fetchServicesByCategory(category.id);
      });
    },
    /**
     * @description Найти категорию в прайс-листе
     *
     * @param categoryId Id категории
     * @param PriceId Id Прайса
     * @return {ServiceCategory}
     */
    findCategoryFromServicePriceList(categoryId, PriceId) {
      const price = this.pricesList.find((candidate) => candidate.id === PriceId);
      return price.serviceCategories.find((candidate) => candidate.id === categoryId);
    },
    /**
     * @description Найти категорию в прайс-листе по умолчанию
     *
     * @param categoryId Id категории
     * @return {ServiceCategory}
     */
    findCategoryFromDefaultServicePriceList(categoryId) {
      const price = this.pricesList.find((candidate) => candidate.id === null);
      return price.serviceCategories.find((candidate) => candidate.id === categoryId);
    },
    /**
     * @description Обработать изменение порядка категории.
     * @param {object} data Идентификаторы категорий ("Выбранная", "Наведенная").
     * @returns {void}
     */
    async onChangeOrderCategory(data) {
      const selectedElementId = Number(data.selectedElementId);
      const enteredElementId = Number(data.enteredElementId);
      const enteredElement = this.findCategoryById(enteredElementId);
      if (!enteredElement) {
        return;
      }
      const priceList = this.findPriceListById(enteredElement.priceId);
      if (!priceList) {
        return;
      }
      const enteredIndex = priceList.serviceCategories.indexOf(enteredElement);
      this.setNewPositionOnCategoriesList(priceList.id, selectedElementId, enteredIndex);
      priceList.sortCategories();
      const request = this.createCategoryOrderRequest(priceList);
      await this.onEditCategories(request);
      this.fetchServiceCategoriesList();
    },

    /**
     * @description Обработать изменение порядка услуг.
     * @param data
     */
    onChangeOrderServices(data) {
      const selectedElementId = Number(data.selectedElementId);
      const enteredElementId = Number(data.enteredElementId);
      if (selectedElementId === enteredElementId) {
        return;
      }
      const { indexBeforeService, indexSelectedService } = this
        .setNewPositionInServices(selectedElementId, enteredElementId);
      if (indexBeforeService === indexSelectedService) {
        return;
      }
      const request = this.createServiceEditRequest();
      this.onEditServices(request);
    },

    /**
     * @description Вставляем в список категорий новую позицию категории
     *
     * @param {number} priceListId
     * @param {number} selectedElementId
     * @param {number} enteredIndex
     */
    setNewPositionOnCategoriesList(priceListId, selectedElementId, enteredIndex) {
      const priceList = this.findPriceListById(priceListId);
      if (!priceList) {
        return;
      }
      const categoryList = priceList.serviceCategories;
      const element = categoryList.find((category) => category.id === selectedElementId);
      if (!element) {
        return;
      }
      const elementIndex = categoryList.indexOf(element);
      if (elementIndex === -1) {
        return;
      }
      categoryList.splice(elementIndex, 1);
      categoryList.splice(enteredIndex, 0, element);
    },

    /**
     * @description Вставляем в список услуг новую позицию новой услуги
     *
     * @param {number} selectedServiceId Id Выбранной услуги
     * @param {number} beforeServiceId   Id Услуги перед которой будет вставлена услуга
     *
     * @returns {Object}
     */
    setNewPositionInServices(selectedServiceId, beforeServiceId) {
      if (selectedServiceId === beforeServiceId) {
        return {};
      }
      const selectedService = this.serviceList.find((el) => el.id === selectedServiceId);
      const beforeService = this.serviceList.find((el) => el.id === beforeServiceId);
      const indexSelectedService = this.serviceList.indexOf(selectedService);
      this.serviceList.splice(indexSelectedService, 1);
      const indexBeforeService = this.serviceList.indexOf(beforeService);
      this.serviceList.splice(indexBeforeService, 0, selectedService);
      return { indexBeforeService, indexSelectedService };
    },

    /**
     * @description Найти категорию по Id.
     * @param {number} categoryId
     * @returns {object | undefined}
     */
    findCategoryById(categoryId) {
      return this.pricesList
        .flatMap((priceList) => priceList.serviceCategories)
        .find((category) => category.id === categoryId);
    },

    /**
     * @description Найти прайс-лист по Id.
     * @param {number} priceListId
     * @returns {ServicePriceList | undefined}
     */
    findPriceListById(priceListId) {
      return this.pricesList.find((priceList) => priceList.id === priceListId);
    },

    /**
     * @description Создать запрос для обновления порядка категорий.
     * @param {ServicePriceList} priceList
     * @returns {object}
     */
    createCategoryOrderRequest(priceList) {
      return {
        categories: priceList.serviceCategories.map((category, index) => ({
          id: category.id,
          order: index,
        })),
      };
    },

    /**
     * @description Создать запрос для обновления услуг.
     * @returns {object}
     */
    createServiceEditRequest() {
      return {
        services: this.serviceList.map((category, index) => ({
          id: category.id,
          order: index,
        })),
      };
    },

    /**
     * @description Открыть форму для работы с категорией.
     * @param {ServiceCategory|null} category Категория.
     * @param {ServicePriceList|null} price Прайс.
     * @returns {void}
     */
    async openCategoryForm(category = null, price = null) {
      this.formName = '';
      this.$nextTick(() => {
        this.selectedPrice = Maybe.fromEmpty(price);
        this.selectedCategory = Maybe.fromEmpty(category);
        this.formName = this.$options.formCategory;
      });
    },
    /**
     * @description Открыть форму для работы с прайс-листом.
     * @param {ServicePriceList|null} price Прайс.
     * @returns {void}
     */
    async openPriceForm(price = null) {
      this.formName = '';
      this.$nextTick(() => {
        this.selectedPrice = Maybe.fromEmpty(price);
        this.formName = this.$options.formPrice;
      });
    },
  },
};

/**
 * @description Примесь услуг.
 * @type {Vue}
 */
const serviceMixin = {
  computed: {
    /**
     * @description Заголовок формы услуг.
     * @type {string}
     */
    formServiceTitle() {
      return this.serviceId !== null
        ? 'Редактирование услуги'
        : 'Создание услуги';
    },
    /**
     * @description Идентификатор выбранной услуги.
     * @type {number|null}
     */
    serviceId() {
      return this.selectedService.fold(null)((service) => service.id);
    },
    /**
     * @description Поля услуги.
     * @type {any}
     */
    serviceProps() {
      return this.selectedService.fold({})((service) => ({
        initialCode: service.code,
        initialCategoryId: service.categoryId,
        initialColor: service.color,
        initialItemType: service.itemType,
        initialName: service.name,
        initialPrice: service.price,
        initialTaxCode: service.taxCode,
        initialUnits: service.units,
        initialClinicCode: service.clinicCode,
        initialPriceId: service.priceListId,
        initialOrder: service.order,
      }));
    },
  },
  data() {
    return {
      /**
       * @description Выбранная услуга.
       * @type {Maybe<Service>}
       */
      selectedService: Maybe.none(),
      /**
       * @description Показывать диалог подтверждения удаления услуги.
       * @type {boolean}
       */
      shownDialogConfirmDeleteService: false,
    };
  },
  methods: {
    /**
     * @description Обработать копирование услуги.
     * @param {number} serviceId Идентификатор услуги.
     * @returns {void}
     */
    onCopyService(serviceId) {
      const service = this
        .serviceList
        .find((candidate) => candidate.id === serviceId)
        .copyWithoutIdentity();
      this.openServiceForm(service);
    },
    /**
     * @description Обработать создание услуги.
     * @param {any} request Запрос.
     * @returns {void}
     */
    onCreateService(request) {
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.onCloseForm();
        this.onSelectingCategory(result.service.categoryId);
        this.notifySuccess(result.message);
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .sendCreateService(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать удаление услуги.
     * @returns {void}
     */
    onDeleteService() {
      const { serviceId } = this;
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.onCloseForm();
        this.serviceList = this
          .serviceList
          .filter((candidate) => candidate.id !== serviceId);
        this.notifySuccess(result.message);
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .sendDeleteService(serviceId)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => {
          this.isAwaitRequest = false;
          this.shownDialogConfirmDeleteService = false;
        });
    },
    /**
     * @description Обработать редактирование услуги.
     * @param {EditServiceRequest} request Запрос.
     * @returns {void}
     */
    onEditService(request) {
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        let errorTitle = error.getTitle();
        if (request.showViolationOnNotifier()) {
          const fieldError = resolveInputErrors('service.code');
          errorTitle += `. ${fieldError(this)}`;
        }
        this.notifyFail(errorTitle);
      };
      const onSuccess = (result) => {
        this.onCloseForm();
        const serviceId = result.service.id;
        const index = this.serviceList.findIndex((item) => item.id === serviceId);
        if (index !== -1) {
          this.$set(this.serviceList, index, result.service);
        }
        const { title, body } = result.onBoardingStatus;
        this.checkAndUpdate(title, body);
        this.notifySuccess(result.message);
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .sendEditService(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать редактирование услуг.
     * @param {EditServiceRequest} request Запрос.
     * @returns {void}
     */
    onEditServices(request) {
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (result) => {
        this.notifySuccess(result.message);
      };
      this.isAwaitRequest = true;
      this
        .$serviceGateway
        .sendEditServices(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Обработать отправку формы услуги.
     * @param {any} props Поля услуги.
     * @returns {void}
     */
    onFormServiceSubmit(props) {
      if (this.validateServiceProps(props)) {
        if (this.serviceId) {
          const request = new EditServiceRequest(this.serviceId, props, true);
          this.onEditService(request);
        } else {
          const request = new CreateServiceRequest(props);
          this.onCreateService(request);
        }
      }
    },
    /**
     * @description Обработать открытие диалога подтверждения удаления услуги.
     * @param {number} serviceId Идентификатор услуги.
     * @returns {void}
     */
    onOpenDialogConfirmDeleteService(serviceId) {
      const service = this.serviceList.find((candidate) => candidate.id === serviceId);
      this.selectedService = Maybe.fromEmpty(service);
      this.selectedService.forEach(() => { this.shownDialogConfirmDeleteService = true; });
    },
    /**
     * @description Обработать открытие формы услуг.
     * @param {number|null} serviceId Идентификатор услуги.
     * @returns {void}
     */
    onOpenServiceForm(serviceId = null) {
      const service = serviceId
        ? this.serviceList.find((candidate) => candidate.id === serviceId)
        : null;
      this.openServiceForm(service);
    },
    /**
     * @description Переключить наличие в услуги в списке избранного.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    onToggleFavorite(id) {
      const service = this.serviceList.find((item) => item.id === id);
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (message) => {
        service.isFavorite = !service.isFavorite;
        this.notifySuccess(message);
        if (this.categoryId === 'favorites') {
          this.serviceList = this.serviceList.filter((item) => item.isFavorite);
        }
      };
      this.isAwaitRequest = true;
      const response = service.isFavorite
        ? this.$serviceGateway.removeFromFavoriteList(service.id)
        : this.$serviceGateway.addToFavoriteList(service.id);
      response
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Переключить наличие в услуги в списке скрытытх услуг.
     * @param {number} id Идентификатор услуги.
     * @returns {void}
     */
    onToggleHidden(id) {
      const service = this.serviceList.find((item) => item.id === id);
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (message) => {
        service.isHidden = !service.isHidden;
        this.notifySuccess(message);
        if (this.categoryId === 'hidden') {
          this.serviceList = this.serviceList.filter((item) => item.isHidden);
        }
      };
      this.isAwaitRequest = true;
      const response = service.isHidden
        ? this.$serviceGateway.removeFromHiddenList(service.id)
        : this.$serviceGateway.addToHiddenList(service.id);
      response
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Открыть окно создания элементов услуг
     * @return {void}
     */
    openServiceItemForm() {
      this.formName = FORM_SERVICE_ITEM;
    },
    /**
     * @description Открыть форму для работы с услугой.
     * @param {Service|null} service Услуга.
     * @returns {void}
     */
    openServiceForm(service = null) {
      this.formName = '';
      this.$nextTick(() => {
        this.selectedService = Maybe.fromEmpty(service);
        this.formName = this.$options.formService;
      });
    },
    /**
     * @description Обработать валидацию полей услуги.
     * @param {Object} props Поля услуги.
     * @returns {boolean}
     */
    validateServiceProps(props) {
      const violationList = new ViolationList();
      if (!props.name) {
        violationList.push('service.name', violations.service.name.empty);
      } else if (validateServiceName(props.name) === false) {
        violationList.push('service.name', violations.service.name.format);
      }
      if (!props.categoryId) {
        violationList.push('service.category', violations.service.category.empty);
      }
      if (!props.priceListId && !props.categoryId) {
        violationList.push('service.price_list_id', violations.service.price_list.empty);
      }
      if (props.price === '') {
        violationList.push('service.price', violations.service.price.empty);
      }
      if (props.units && validateServiceUnits(props.units) === false) {
        violationList.push('service.units', violations.service.units.format);
      }
      this.inputErrors = violationList.getCauses();
      return violationList.hasCauses() === false;
    },
  },
};

/**
 * @description Список услуг.
 * @type {any}
 */
export default {
  formPrice: FORM_PRICE,
  formCategory: FORM_CATEGORY,
  formService: FORM_SERVICE,
  formServiceItem: FORM_SERVICE_ITEM,
  components: {
    IncreaseServicePricesModal,
    FormServiceItem,
    FormPrice,
    PriceList,
    PriceInput,
    OnBoardingDialog,
    NextStepSettingInstruction,
    ButtonBack,
    ZoomImage,
    ConfirmSideDialog,
    CategoryItem,
    ServiceTable,
    SideSlideTransition,
    FormServiceCategoryCreation,
    FormServiceCreation,
    ModalDialog,
    InputTextSearch,
  },
  computed: {
    /**
     * @description Есть разрешение на увеличение цены.
     * @returns {boolean}
     */
    isAllowIncreasePrice() {
      return this.actions.includes('edit');
    },
    /**
     * @description Выбрана хотя бы одна услуга для увеличения.
     * @returns {boolean}
     */
    isSelectedIncreaseService() {
      return this.increaseServicePrices.length > 0;
    },
    /**
     * Готова ли страница к показу ОнБординга
     *
     * @return {boolean}
     */
    isReadyToOnBoarding() {
      return this.hasCreate;
    },
    /**
     * @description Показывать ли онбординг
     * @return {boolean}
     */
    isShowOnboarding() {
      return !this.step.isPassed && this.step.isAccess;
    },
    /**
     * Показываем представление "Изменить цену услуги"
     *
     * @return {boolean}
     */
    isShowButtonEditPricePriceList() {
      return this.step?.notShowedView === 'price-list-button-price-edit' && this.category.isSome() && this.serviceList.length > 0;
    },
    /**
     * Показываем представление "Показать дополнительные функции"
     *
     * @return {boolean}
     */
    isShowButtonsCreatingFunctionsPriceList() {
      return this.step?.notShowedView === 'price-list-button-creating-function';
    },
    /**
     * @description Имеется открытая форма.
     * @type {boolean}
     */
    hasOpenForm() {
      return this.formName !== '';
    },
    /**
     * @description Деактивировать выгрузку в Excel.
     * @type {boolean}
     */
    disabledExport({ isAwaitLoadCategories, categoryList, pricesList }) {
      return isAwaitLoadCategories || (categoryList.length === 0 && pricesList.length === 0);
    },
    /**
     * @description Имеет право создавать услуги.
     * @type {boolean}
     */
    hasCreate() {
      return this.actions.includes('add');
    },
    /**
     * @description Имеет право удалять услуги.
     * @type {boolean}
     */
    hasDelete() {
      return this.actions.includes('delete');
    },
    /**
     * @description Имеет право редактировать услуги.
     * @type {boolean}
     */
    hasEdit() {
      return this.actions.includes('edit');
    },
    /**
     * @description Сообщение при отсутствии данных.
     * @type {any}
     */
    message(vm) {
      if (vm.inSearchProcess && vm.isSearchNotFound) {
        return {
          action: () => { this.searchQuery = ''; },
          text: 'Услуг с таким именем не найдено',
        };
      }
      if (vm.isAwaitLoadCategories || vm.isAwaitLoadServices) {
        return '';
      }
      if (vm.categoryList.length === 0 && vm.pricesList.length === 0) {
        return {
          action: () => this.openCategoryForm(),
          text: 'Добавьте категории или прайсы',
        };
      }
      if (vm.category.isNone()) {
        return {
          action: () => {},
          text: 'Выберите категорию',
        };
      }
      if (vm.serviceList.length === 0 && vm.category.id === 'favorites') {
        return {
          action: () => {},
          text: 'Список избранного пуст',
        };
      }
      if (vm.serviceList.length === 0) {
        return {
          action: () => this.openServiceForm(),
          text: 'Добавить новую услугу',
        };
      }
      return '';
    },
    /**
     * @description Список категорий.
     * @type {any[]}
     */
    categories({ categoryList, $options }) {
      return [$options.allCategory, ...categoryList, $options.favoriteCategory];
    },
    /**
     * @description Заголовок формы.
     * @type {string}
     */
    formTitle() {
      const titleFormMap = {
        [this.$options.formPrice]: this.formPriceTitle,
        [this.$options.formCategory]: this.formCategoryTitle,
        [this.$options.formService]: this.formServiceTitle,
      };
      return titleFormMap[this.formName] ?? '';
    },
    needConfirmPriceForm: needConfirm(FORM_PRICE),
    needConfirmServiceForm: needConfirm(FORM_SERVICE),
    needConfirmCategoryForm: needConfirm(FORM_CATEGORY),
  },
  updated() {
    this.definePositionAndSetPositionsToChildComponent(
      this.isShowButtonEditPricePriceList,
      '#price-list-button-price-edit-parent',
      '#price-list-button-price-edit-child',
      'tr',
    );
    this.definePositionAndSetPositionsToChildComponent(
      this.isShowButtonsCreatingFunctionsPriceList,
      '#price-list-button-creating-function-parent-1',
      '#price-list-button-creating-function-child-1',
      'bl',
    );
    this.definePositionAndSetPositionsToChildComponent(
      this.isShowButtonsCreatingFunctionsPriceList,
      '#price-list-button-creating-function-parent-2',
      '#price-list-button-creating-function-child-2',
      'bl',
    );
  },
  async created() {
    this.fetchInstructionSteps();
    await this.fetchServiceCategoriesList();
    const firstCategoryId = this.pricesList?.[0]?.serviceCategories?.[0]?.id;
    if (firstCategoryId) {
      this.onSelectingCategory(firstCategoryId);
    }
  },
  data() {
    const needConfirmBeforeClosed = {};
    needConfirmBeforeClosed[FORM_PRICE] = false;
    needConfirmBeforeClosed[FORM_CATEGORY] = false;
    needConfirmBeforeClosed[FORM_SERVICE] = false;
    return {
      /**
       * @description Раскрытая панель прайс-листа.
       * @type {Number}
       */
      servicePriceListPanel: 0,
      /**
       * @description Допустимые действия.
       * @type {string[]}
       */
      actions: [],
      /**
       * @description Ожидание выполнения запрос.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Название открытой формы.
       * @type {string}
       */
      formName: '',
      /**
       * @description Список категорий.
       * @type {Array}
       */
      categoryList: [],
      /**
       * @description Список папок.
       * @type {Array<ServicePriceList>}
       */
      pricesList: [],
      /**
       * @description Список нарушений ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description В процессе поиска
       * @type {boolean}
       */
      inSearchProcess: false,
      /**
       * @description Поиск не дал результатов
       * @type {boolean}
       */
      isSearchNotFound: false,
      /**
       * @description Ожидание загрузки списка категорий.
       * @type {boolean}
       */
      isAwaitLoadCategories: false,
      /**
       * @description Ожидание загрузки списка услуг.
       * @type {boolean}
       */
      isAwaitLoadServices: false,
      /**
       * @description Ошибки в поисковом запросе
       * @type {Array}
       */
      searchViolations: [],
      /**
       * @description поисковая строка по услугам
       * @type {String}
       */
      searchQuery: '',
      /**
       * @description Список услуг в категории.
       * @type {Array}
       */
      serviceList: [],
      /**
       * @description Отображать данные при поиске.
       * @type {boolean}
       */
      shownSearchColumns: false,
      /**
       * @description Показывать диалоговое окно подсказки.
       * @type {boolean}
       */
      showHintDialog: false,
      /**
       * элемент на который навились через drag
       * @type {HTMLElement}
       */
      dragSelectedElement: null,
      /**
       * Слаг шага ОнБординга
       * @type {string}
       */
      stepSlug: 'insert-price-in-price-list',
      /**
       * @description Необходимо подтверждение перед закрытием формы.
       * @type {any}
       */
      needConfirmBeforeClosed,
      /**
       * @description Выбранные услуги для настройки.
       * @type Array<Number>
       */
      increaseServicePrices: [],
      /**
       * @description Показывать ли модальное окно услуг.
       * @type {boolean}
       */
      isShowIncreaseServicePricesModal: false,
    };
  },
  favoriteCategory: {
    id: 'favorites',
    name: 'Услуги для записи в расписание',
  },
  allCategory: {
    id: 'all',
    name: 'Все',
  },
  methods: {
    /**
     * @description Обработать событие отправки формы увеличения цены.
     * @param request
     * @returns {Promise<void>}
     */
    async onIncreaseServicePrice(request) {
      const onSuccess = (result) => {
        this.onCloseIncreaseServicePricesModal();
        this.reloadCategoryList();
        this.category = Maybe.none();
        this.reloadIncreaseServicePrices();
        const { message } = result;
        this.notifySuccess(message);
      };
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      this.isAwaitRequest = true;
      await this
        .$serviceGateway
        .increaseServicePrices(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isAwaitRequest = false; });
    },
    /**
     * @description Сбросить услуги для увеличения.
     * @returns {void}
     */
    reloadIncreaseServicePrices() {
      this.increaseServicePrices = [];
    },
    /**
     * @description Открыть модальное окно увеличения цены услуг.
     * @returns {void}
     */
    onOpenIncreaseServicePricesModal() {
      if (this.increaseServicePrices.length === 0) {
        this.notifyError('Выберите услуги');
        return;
      }
      this.isShowIncreaseServicePricesModal = true;
    },
    /**
     * @description Закрыть модальное окно увеличения цены услуг.
     * @returns {void}
     */
    onCloseIncreaseServicePricesModal() {
      this.isShowIncreaseServicePricesModal = false;
    },
    /**
     * @description Обработать события удаления услуги для увеличения
     * @param id
     */
    onRemoveFromIncreaseServices(id) {
      this.increaseServicePrices = this
        .increaseServicePrices
        .filter((item) => item.id !== id);
    },
    /**
     * @description Обработать события добавления к услугам для увеличения
     * @param id
     */
    onAddToIncreaseServices(id) {
      this.increaseServicePrices.push(this.serviceList.find((item) => item.id === id));
    },
    /**
     * @description Запросить список категорий услуг
     *
     * @return {Promise<void>}
     */
    async fetchServiceCategoriesList() {
      this.isAwaitLoadCategories = true;
      const result = await this.$serviceGateway.getServicePriceListsForView();
      const {
        actions, prices, onBoardingStatus,
      } = result
        .fold({ actions: [], categories: [], onBoardingStatus: {} })((response) => response);
      const { title, body } = onBoardingStatus;
      this.checkAndUpdate(title, body);
      this.pricesList = prices;
      this.actions = actions;
      this.isAwaitLoadCategories = false;
    },
    /**
     * @description Закрыть форму.
     * @returns {void}
     */
    onCloseForm() {
      this.formName = '';
      this.inputErrors = {};
      this.selectedPrice = Maybe.none();
      this.selectedService = Maybe.none();
      this.selectedCategory = Maybe.none();
    },
    /**
     * @description Обработать событие наведения на элемент
     * через "drag"
     * @param {HTMLElement|null} element Идентификатор категории.
     * @returns {void}
     */
    onSetDragSelectedElement(element) {
      this.dragSelectedElement = element;
    },
    /**
     * @description выполнить поиск
     */
    searchServiceList: debounce(async function _() {
      this.searchViolations = [];
      this.isSearchNotFound = false;
      if (this.searchQuery.length === 0) {
        await this.reloadCategoryList();
        return;
      }
      if (this.searchQuery.length < 3) {
        this.searchViolations.push('Необходимо ввести не менее 3-х символов');
        return;
      }
      const response = await this.$serviceGateway.searchWithCategories(this.searchQuery);
      this.inSearchProcess = true;
      if (response.title) {
        this.isSearchNotFound = true;
        return;
      }
      let allServices = [];
      const categories = response;
      categories.forEach((category) => {
        allServices = allServices.concat(category.services);
      });
      this.$options.allCategory.services = allServices;
      this.categoryList = [...categories];
      this.shownSearchColumns = true;
      this.category = Maybe.fromEmpty(this.$options.allCategory);
      this.serviceList = allServices;
    }, 300),
    /**
     * @description Перезагрузить список категорий и по возможности выбрать текущую.
     * @returns {void}
     */
    async reloadCategoryList() {
      this.inSearchProcess = false;
      const result = await this.$serviceGateway.getServicePriceListsForView();
      const { actions, onBoardingStatus } = result
        .fold({ actions: [], categories: [] })((response) => response);
      const { title, body } = onBoardingStatus;
      this.checkAndUpdate(title, body);
      this.actions = actions;
      if (this.categoryId === 'all') {
        this.onSelectingCategory(this.categoryList[0].id);
      } else {
        this.onSelectingCategory(this.categoryId);
      }
    },
    /**
     * @description Обработать выгрузку в Excel.
     * @returns {void}
     */
    async onExportExcel() {
      if (this.categoryList.length === 0 && this.pricesList.length === 0) {
        return;
      }
      const onFail = (error) => {
        if (error.title) {
          this.notifyFail(error.title);
        }
      };
      const onSuccess = (file) => {
        saveFile(file, 'Прайс клиники.xls');
      };
      const either = await this.$serviceGateway.downloadPriceList();
      either.fold(onFail, onSuccess);
    },
    /**
     * @description Обработать установку кода услуги для всех услуг категории.
     * @param {number}  categoryId Идентификатор категории.
     * @param {?string} taxCode    Код услуги для налоговой.
     * @returns {void}
     */
    onSetTaxCodeForAllServicesInCategory(categoryId, taxCode) {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (message) => {
        this.notifySuccess(message);
        if (this.categoryId === categoryId) {
          this.fetchServicesByCategory(categoryId);
        }
      };
      const category = this
        .categoryList
        .find((candidate) => candidate.id === categoryId);
      const categoryName = category ? category.name : '';
      this
        .showDialog(
          `Применить код ко всем услугам раздела "${categoryName}"?`,
          DialogResult.YES,
          DialogResult.NO,
        )
        .then((dialog) => {
          if (dialog.result !== DialogResult.YES) {
            return;
          }
          this.isAwaitRequest = true;
          this
            .$serviceGateway
            .setTaxCodeForAllServicesInCategory(categoryId, taxCode)
            .then((result) => result.fold(onFail, onSuccess))
            .finally(() => { this.isAwaitRequest = false; });
        });
    },
    /**
     * @description Обработать изменения значимых полей формы.
     * @param {string}  name      Название формы.
     * @param {boolean} isChanged Есть изменения.
     * @returns {void}
     */
    onChangeFieldValues(name, isChanged) {
      this.needConfirmBeforeClosed[name] = isChanged;
    },
  },
  name: 'ClinicPanelServicePriceList',
  mixins: [
    onBoardingMixin,
    onBoardingShowMixin,
    categoryMixin,
    notifierMixin,
    serviceMixin,
    settingInstructionMixin,
    builtInDialogMixin,
  ],
  serviceTaxCodeOptions: [
    { title: '-', value: null },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
  ],
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.v-snack__content {
  white-space: pre-line;
}
.service {
  &-message {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex: 1;
    color: var(--action-color);
    font-size: 24px;
    cursor: default;
  }
  &-page {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    height: 100%;
    padding-bottom: 68px;
    &__on-boarding {
      &__edit-price {
        width: 120px;
        height: 20px;
        background-color: white;
      }
      &__add {
        @include buttons.btn-blue(225px, 48px, 16px);
        max-width: 100%;
        @include buttons.btn-blue-add(19px);
        height: 50px;
      }
    }
    &__aside {
      &__button {
        &-filters {
          @include buttons.btn-transparent(100%, 48px, 16px);
          margin: 20px 0 0 0;
          &:before {
            content: "";
            background-image: url("@/assets/img/exel.svg");
            background-repeat: no-repeat;
            background-size: contain;
            width: 16px;
            height: 16px;
            margin: 0 8px 0 0;
          }
        }
      }
    }
    &__header {
      display: flex;
      gap: 30px;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: flex-start;
      padding-bottom: 38px;

      &__left {
        display: flex;
        flex-direction: column;
        gap: 10px;
        flex-grow: 1;
      }
      &__buttons {
        display: flex;
        gap: 10px;
        flex-flow: row wrap;
      }
      &__button {
        &-add {
          @include buttons.btn-blue(225px, 48px, 16px);
          max-width: 100%;
          @include buttons.btn-blue-add(19px);
        }
        &-edit-prices {
          @include buttons.btn-transparent(225px, 48px, 16px);
          max-width: 100%;
          &:before {
            content: "";
            background-repeat: no-repeat;
            background-size: contain;
            margin: 0 8px 0 0;
          }
        }
        &-export {
          @include buttons.btn-transparent(225px, 48px, 16px);
          max-width: 100%;
          &:before {
            content: "";
            background-image: url("@/assets/img/exel.svg");
            background-repeat: no-repeat;
            background-size: contain;
            width: 16px;
            height: 16px;
            margin: 0 8px 0 0;
          }
          &:disabled {
            border-color: var(--unfocus-color);
            color: var(--unfocus-color);
            &:before {
              background-image: url("@/assets/img/exel-grey.svg");
            }
          }
        }
      }
    }
    &__search {
      padding: 8px 0 0 0;
      margin: 0;
      min-height: 64px;
    }
    &__body {
      padding: 38px 20px 48px 23px;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;
      &__row {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }
    }
    &__title {
      display: flex;
      flex-flow: row wrap;
      align-items: baseline;
      gap: 10px 30px;
      button {
        font-size: 18px;
        font-weight: 500;
        color: #90a0b7;
        &:hover {
          color: #0489E0;
        }
      }
    }
    &__modal {
      &__article {
        display: grid;
        row-gap: 10px;
        margin-block: 30px 10px;
      }
      &__img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
        margin: 10px 0;
      }
      h4 {
        margin-bottom: 15px;
      }
      p,
      ol,
      ul {
        margin-bottom: 10px !important;
      }
    }
    &__categories {
      width: 280px;
      &__caption {
        font-size: 14px;
        line-height: 17px;
        font-weight: 700;
        border-bottom: 2px solid #0489e0;
        padding: 13px 10px 14px;
      }
      &__container {
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 280px;
        background: #f2f7fa;
        padding: 20px 10px;
      }
    }
    &__dialog {
      &__buttons {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        margin: 20px 0;
      }
      &__button {
        &.positive{
          @include buttons.btn-blue(100%, 40px, 16px);
        }
        &.negative {
          @include buttons.btn-transparent(100%, 40px, 16px);
        }
      }
    }
  }
}
@media screen and (max-width: 1190px) {
  .service-page__body__row {
    grid-template-columns: 1fr;
  }
  .service-page__categories {
    width: 100%;
    margin: 0;
    &__caption {
      padding: 10px;
    }
    &__container {
      height: fit-content;
      width: 100%;
    }
  }
  .service-page__search {
    min-height: auto;
  }
}
@media screen and (max-width: 960px) {
  .service {
    &-page {
      flex-direction: column;
    }
  }
}

@media screen and (max-width: 714px) {
  .service {
    &-page {
      padding-bottom: 127px;
    }
  }
}

@media screen and (max-width: 700px) {
  .service {
    &-page {
      &__body {
        overflow-y: initial;
        overflow-x: initial;
        &__row {
          padding-bottom: 200px;
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .service {
    &-page {
      &__body {
        padding: 38px 10px 140px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .service-page {
    &__header {
      &__button {
        &-export {
          display: none;
        }
      }
    }
    &__dialog {
      &__buttons {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>
